import Header from './components/Header/Header';
import './App.css';
import Landing from './components/Landing/Landing';
import Works from './components/Works/Works';
import About from './components/About/About';
import Contact from './components/Contact/Contact';



function App() {
  return (
    <div >
      <Header />
      <Landing />
      <Works />
      <About />
      <Contact />
    </div>
  );
}

export default App;
